import "./styleFile.css"
export const Article = (props) => {

  var styles = {
    backgroundColor: '#' + props.color};
  const onclickCard = (link) => {
    window.open(props.link, '_blank');
  }
  return (
    <article className="article"  >
      <h3 className="article__category" style={styles} onClick={onclickCard}>{props.category}</h3>
      <h2 className="article__title" onClick={onclickCard}>{props.title}</h2>
      <p className="article__excerpt" onClick={onclickCard}>{props.details}</p>
    </article>
  )

}
